export function calculateTextBlockHeight(textArray, maxWidth, fontSize) {
  // An array to store the words for each line of text
  let lines = []
  // An array to store words in the current line being processed
  let currentLine = []
  // A variable to track the total width of the current line
  let currentLineWidth = 0

  // Loop through each text object in the input array
  textArray.forEach((textObj) => {
    // Skip if text is null/undefined
    if (!textObj || !textObj.text) return
    // Split the text into individual words
    const words = textObj.text.split(" ")

    // Loop through each word
    words.forEach((word) => {
      // Calculate the width of the word with the specified font and size
      const wordWidth = textObj.font.widthOfTextAtSize(word, fontSize)

      // Check if adding the word to the current line would exceed the maxWidth
      if (currentLineWidth + wordWidth <= maxWidth) {
        // If not, add the word to the current line and update the line width
        currentLine.push({ text: word, font: textObj.font })
        currentLineWidth += wordWidth + textObj.font.widthOfTextAtSize(" ", fontSize)
      } else {
        // If it would, add the current line to the lines array
        lines.push(currentLine)
        // Start a new line with the current word and update the line width
        currentLine = [{ text: word, font: textObj.font }]
        currentLineWidth = wordWidth + textObj.font.widthOfTextAtSize(" ", fontSize)
      }
    })
  })

  // Add the last line to the lines array
  lines.push(currentLine)

  // Calculate the total height of the text block
  const textBlockHeight = lines.length * fontSize * 1.5
  return textBlockHeight
}
